/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endliveroomonly3Inputs */

const en_endliveroomonly3 = /** @type {(inputs: Endliveroomonly3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only end the Live Room`)
};

const de_endliveroomonly3 = /** @type {(inputs: Endliveroomonly3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur Live Room beenden`)
};

/**
* | output |
* | --- |
* | "Only end the Live Room" |
*
* @param {Endliveroomonly3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const endliveroomonly3 = /** @type {((inputs?: Endliveroomonly3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endliveroomonly3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_endliveroomonly3(inputs)
	return de_endliveroomonly3(inputs)
});
export { endliveroomonly3 as "endLiveRoomOnly" }